import { render, staticRenderFns } from "./Payee.vue?vue&type=template&id=767e9eae"
import script from "./Payee.vue?vue&type=script&lang=js"
export * from "./Payee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports